import { useEffect } from "react";

const EsignAgreement = (props) => {
  const handleEsign = () => {
    let esignlink = props?.$store?.esignlink;
    console.log({ esignlink });

    if (esignlink) window.open(esignlink, "_blank");

    props.store("user", {
      ...props?.$store?.user,
      is_agreement_signed: true,
    });
    props.handleEsignSubmit();
  };

  return (
    <div className="py-4">
      <p>
        We have sent you an E-Sign agreement in your registered mail id . Please
        click on the below link to E-Sign your agreement .
      </p>
      <div className="col-12 col-md-12 mt-4 d-flex justify-content-end">
        <button
          className="formdata-cancel-btn btn"
          onClick={(...args) => props.onModalClose(...args)}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary ms-3"
          onClick={(...args) => handleEsign(...args)}
        >
          Click here to E-Sign
        </button>
      </div>
    </div>
  );
};

export default constore(EsignAgreement);
